import { authenticatedClient } from '../lib/client';
import { WORKFLOW_ENDPOINTS } from './workflow.utils';
import type { WorkflowTokenResponse } from './workflow.types';
import type { ApiResponse } from '../lib/types';

export const getWorkflowToken = async (): Promise<ApiResponse<string>> => {
    try {
        const response = await authenticatedClient.get<WorkflowTokenResponse>(
            WORKFLOW_ENDPOINTS.GET_TOKEN
        );
        
        if (!response.data?.token) {
            throw new Error('Token not found in response');
        }
        
        return { data: response.data.token };
    } catch (error: any) {
        return { 
            error: error.response?.data?.message || 'Failed to get workflow token',
            status: error.response?.status
        };
    }
};
